
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import Reorder, { reorder } from 'react-reorder'
import {
  Link,
  useNavigate,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  useApiRouter,
  appRouter,
  C,
  logg, loggt,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import {
  IncludeUbprs,
  ReportsCtx,
  TriSelect,
} from '$src/components/reports'

library.add( faFilter, faInfoCircle, faSearch, faTimes )


/*
 * ReportModal
**/
const ReportModal = (props) => {
  // logg(props, 'ReportModal')

  const apiRouter = useApiRouter()
  const nagivate = useNavigate()

  const {
    report_id,
  } = useParams()
  // logg(useParams(), 'params')

  /* ctx */

  const {
    setLoading,
  } = useContext(AppCtx)

  const {
    reportsList,                             refreshReportsList,
    reportModalOpen,  setReportModalOpen,
    reportsModalOpen, setReportsModalOpen,
  } = useContext(ReportsCtx)
  // logg(useContext(ReportsCtx), 'ReportsCtx in ReportModal')


  /* state */

  const [ action, setAction ] = useState('new')
  const [ helpOpen, setHelpOpen ] = useState(false)

  const [ modalTitle, setModalTitle ] = useState('New Single FI Report')
  // const [ selectedSchedule, setSelectedSchedule ] = useState(null)
  const [ showAddHeader, setShowAddHeader ] = useState(false)


  const [ addSelected, setAddSelected ] = useState(null)

  const includedUbprsRef = useRef(null)
  const [ headerName, setHeaderName ] = useState('')
  const [ reportName, setReportName ] = useState('')

  const [ filteredUbprsList, setFilteredUbprsList ] = useState([])
  const [ selectedUbprs, setSelectedUbprs ] = useState([])
  const [ eol, setEol ] = useState(null)

  /* effects */

  /* load a report */
  useEffect(() => {
    if (report_id) {
      setAction('edit')
      setLoading(true)
      setReportModalOpen(true) // need this if URL is accessed directly
      fetch(apiRouter.reportPath({ id: report_id })).then(r => r.json()).then(inns => {
        // logg(inns, 'fetched report')
        setModalTitle('Edit Report')
        setReportName(inns.report.name)
        setSelectedUbprs(inns.report.selectedUbprs)
        setLoading(false)
      })
    }
  }, [ report_id ] )

  /* methods */

  const handleSave = () => {
    setLoading(true)
    fetch(report_id ? apiRouter.reportPath({ id: report_id }) : apiRouter.reportsPath(), {
      method: report_id ? 'PATCH' : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        report: {
          name: reportName,
          selectedUbprs,
        },
      }),
    }).then(r => r.json()).then(inns => {
      refreshReportsList()
      toast(`Successfully ${report_id ? 'saved' : 'created'} the report.`)
      setReportModalOpen(false)
      setReportsModalOpen(false)
      nagivate('/banks/results')
      setLoading(false)
    }).catch((err) => {
      logg(err, 'cannot save single fi report')
      toast('Could not save single fi report.')
    })
  }

  return <F>
    <Modal
      className="BaseModal ReportModalDocumentation "
      isOpen={helpOpen}
      onRequestClose={ () => setHelpOpen(false) }
      overlayClassName="ReportModalOverlay2 ModalOverlay-z15"
    >
      <div className='header'>
        <h5>Single FI Reports Documentation</h5>
        <div className='right'>
          <div className='close' style={{ width: '30px' }} onClick={() => {
            setHelpOpen(false) ;
          } }><FontAwesomeIcon icon="fa-solid fa-times"
            style={{ cursor: 'pointer' }}
          /></div>
        </div>
      </div>

      <div className='container'>
        <div className='row mt-3'>
          <p>When you Create a report and then Run it, the resulting Excel csv file would look like this:</p>
          <img src="https://d15g8hc4183yn4.cloudfront.net/wp-content/uploads/2024/10/15141457/2024-10-15-at-3.14.32-PM.jpg" alt="example layout 4 report" />
          <div className='actions mt-4 mb-4'>
            <div className='left'></div>
            <div className='right'>
              <div className='Btn' onClick={() => setHelpOpen(false)}>Ok</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal
      ariaHideApp={false}
      className="BaseModal ReportModal "
      isOpen={reportModalOpen}
      onRequestClose={ () => setReportModalOpen(false) }
      overlayClassName="ReportModalOverlay"
    >
      <div className='header'>
        <h5 >{ modalTitle }</h5>
        <div className='right'>
          <div className='mr-2' style={{ width: '30px', fontSize: '1em' }}>
            <FontAwesomeIcon icon="fa-solid fa-info-circle"
              onClick={() => setHelpOpen(true)}
              style={{ cursor: 'pointer', fontSize: '1.3em', color: '#666' }}
            />
          </div>
          <Link to='/' style={{ color: '#666' }} ><div className='close' style={{ width: '30px' }} onClick={() => {
            setReportModalOpen(false) ;
          } }><FontAwesomeIcon icon="fa-solid fa-times"
            style={{ cursor: 'pointer' }}
          /></div></Link>
        </div>
      </div>

      <div className='container'>{ /* Name */ }
        <div className='row mt-3'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
            <div className='field'>
              <label>Name</label>
              <input name='name' type='text' value={reportName} onChange={(ev) => setReportName(ev.target.value) } />
            </div>
          </div>
        </div>
      </div>

      <div className='row-ubprs bifold-rows'>
        <div className='include-ubprs bordered-scrolling'>
          <TriSelect {...{
            // clear: () => { setSelectedUbprs([]) },
            clear: () => {},
            filteredUbprsList, setFilteredUbprsList,
          }} />
          <IncludeUbprs {...{
            eol, setEol,
            filteredUbprsList, setFilteredUbprsList,
            selectedUbprs, setSelectedUbprs,
          }} />
        </div>
        <div className='flex-col'>
          <div className='field'>
            <label>Add</label>
            <div>
              <Select className=''
                isSearchable={false}
                value={C.addOpts.filter(({ value }) => value === addSelected )}
                onChange={(ev) => {
                  // logg(ev, 'ev')
                  switch(ev.value) {
                    case C.el.h3:
                      setShowAddHeader(true)
                      setAddSelected(ev.value)
                      break;
                    case null:
                      setShowAddHeader(false)
                      setAddSelected(null)
                      break;
                    case C.el.br:
                      setShowAddHeader(false)
                      setAddSelected(null)
                      selectedUbprs.push({ label: '<blank line>', value: C.el.br })
                      setSelectedUbprs(Object.assign([], selectedUbprs))
                      eol.scrollIntoView({ behavior: 'smooth' })
                      break;
                    default:
                      throw 'ezw - this should never happen'
                  }
                } }
                options={C.addOpts}
                style={C.select2Styles}
              />
            </div>
            { showAddHeader && <F>
              <input type='text'
                name='header-name'
                value={headerName}
                onChange={(ev) => setHeaderName(ev.target.value)}
              />
              <button className='Btn'
                onClick={() => {
                  selectedUbprs.push({ value: C.el.h3, label: headerName })
                  setSelectedUbprs(Object.assign([], selectedUbprs))

                  eol.scrollIntoView({ behavior: 'smooth' })
                  setShowAddHeader(false)
                  setAddSelected(null)
                  setHeaderName('')
                } }
              >Add</button>
            </F> }
          </div>
          <div className='included-ubprs bordered-scrolling' ref={includedUbprsRef} >
            <label>Included Line Items ({selectedUbprs.length})</label>
            <Reorder
              onReorder={(ev, prevIdx, nextIdx) => setSelectedUbprs(reorder(selectedUbprs, prevIdx, nextIdx)) }
              reorderId={`report-${report_id}`}
              placeholder={<li />}
            >
              { selectedUbprs.map((item, idx) => <div key={idx} className='ReportItem' >
                <div data-ubpr-code={item.value} className={`bordered label flex-grow ${item.value === C.el.h3 ? 'header' : ''}`} >
                  { item.label }
                </div>
                <div className='' >
                  <div className='Btn' onClick={() => {
                    if ([ C.el.br, C.el.h3 ].indexOf(item.value) !== -1 ) {
                      selectedUbprs.splice( idx, 1 )
                      setSelectedUbprs(Object.assign([], selectedUbprs))
                    } else {
                      setSelectedUbprs(selectedUbprs.filter(({ value }) => value !== item.value ))
                    }
                  } } >&times;</div>
                </div>
              </div> )}
            </Reorder>
            <div className='EOL' ref={(el) => setEol(el) } />
          </div>
        </div>
      </div>

      <div className='actions'>
        <div className='left'></div>
        <div className='right'>
          <div className='Btn btn-primary' onClick={handleSave} >Save</div>
        </div>
      </div>
    </Modal>

  </F>
}
export default ReportModal
